<template>
  <div class="chat-container">
    <a-button class="back" icon="left" @click="back" v-if="id">{{ $t('chat.back') }}</a-button>
    <div class="chat-container-inner">
      <div class="title" v-if="messages.length === 0">
        <div>{{ $t('chat.greeting', { schoolName: schoolName }) }}</div>
        <div>{{ $t('chat.introduction') }}</div>
      </div>
      <!-- <div>
        <div v-for="message in messages" :key="message.id" :class="['message', message.sender]">
          <div class="message-content" style="white-space: pre-line;">{{ message.text }}</div>
        </div>
      </div> -->
      <div class="chat" v-if="messages.length > 0" ref="chatContainer">
        <div v-for="(message, index) in messages" :key="message.id">
          <div class="left">
            <img src="@/assets/icons/robot.png" alt="" v-if="message.type === 'answer'">
          </div>
          <div class="middle">
            <div class="ask" v-if="message.type === 'ask'">
              <div class="attach" v-for="(item, index) in message.attach" :key="index">
                <template v-if="item.type === 'link'">
                  <a :href="item.url" target="_blank" class="link">{{ item.url }}</a>
                </template>
                <template v-else>
                  <img :src="item.url" v-if="item.type === 'image'" alt="">
                  <img :src="getFileIcon(item.name)" v-else alt="">
                  <div>
                    <div class="title">{{ item.name }}</div>
                    <div class="size">{{ item.size }}</div>
                  </div>
                </template>
              </div>
              <div class="ask-input">{{ message.text }}</div>
            </div>
            <div class="answer" v-if="message.type === 'answer'">
              <img class="connecting" v-if="connecting && (messages.length - 1 === index)" src="@/assets/img/connecting.gif" alt="">
              <div class="answer-content">
                {{ message.text }}
              </div>
              <div class="attach" v-if="message.attach.length > 0">
                <div class="info">
                  <span>{{ $t('chat.foundSources', { count: message.attach.length }) }}</span>
                  <img @click="message.showSourceDetail = !message.showSourceDetail" src="@/assets/icons/icon_s_j.png" alt="" :style="{ transform: message.showSourceDetail ? 'rotate(180deg)' : 'none' }">
                </div>
                <div class="detail" v-if="message.showSourceDetail">
                  <div v-for="(item, attachIndex) in message.attach" :key="item.id">{{ attachIndex + 1 }}.{{ item.text }}</div>
                </div>
              </div>
              <div class="stop" v-if="isGenerating && (messages.length - 1 === index) && !connecting" @click="stopGeneration(message)">{{ $t('chat.stopGeneration') }}</div>
              <div class="stop-text" v-if="message.isStop">{{ $t('chat.generationStopped') }}</div>
              <div class="operation" v-if="(index !== messages.length - 1) || !isGenerating">
                <a-tooltip placement="bottom">
                  <template slot="title">
                    <span>{{ playingMessageId === message.id ? $t('chat.stopReading') : $t('chat.voiceReading') }}</span>
                  </template>
                  <div class="list" @click="playAnswer(message)">
                    <img :src="playingMessageId === message.id ? require('@/assets/icons/icon_ai_stop.png') : require('@/assets/icons/icon_ai_play.png')" alt="">
                  </div>
                </a-tooltip>
                <a-tooltip placement="bottom">
                  <template slot="title">
                    <span>{{ $t('chat.copy') }}</span>
                  </template>
                  <div class="list" @click="copyAnswer(message)">
                    <img src="@/assets/icons/icon_copy.png" alt="">
                  </div>
                </a-tooltip>
                <a-tooltip placement="bottom">
                  <template slot="title">
                    <span>{{ $t('chat.download') }}</span>
                  </template>
                  <div class="list" @click="downloadAnswer(message)">
                    <img src="@/assets/icons/icon_download.png" alt="">
                  </div>
                </a-tooltip>
                <a-tooltip placement="bottom">
                  <template slot="title">
                    <span>{{ $t('chat.regenerate') }}</span>
                  </template>
                  <div class="list" @click="regenerateAnswer(message)">
                    <img src="@/assets/icons/icon_again.png" alt="">
                  </div>
                </a-tooltip>
              </div>
            </div>
          </div>
          <div class="right">
            <div v-if="message.type === 'ask'">{{ userName }}</div>
          </div>
        </div>
      </div>
      <div class="messages">
        <div class="app" v-if="!hideApp">
          <div class="header">
            <div class="tab">
              <div
                class="tab-item"
                v-for="(tab, idx) in app"
                :key="idx"
                :class="{ selected: selectedTabIndex === idx }"
                @click="selectedTab(idx)"
              >
                {{ tab.name }}
              </div>
            </div>
            <div class="operation">
              <div v-if="selectedTabIndex >= 0" @click="isTabContentOpen = !isTabContentOpen" :class="{ selectedApp: selectedAppId != defaultAppId }">
                <img v-if="isTabContentOpen" src="@/assets/icons/icon_shouqi.png" alt="">
                <img v-else src="@/assets/icons/icon_zk.png" alt="">
                <span style="color:#000;font-size:14px">{{ isTabContentOpen ? $t('chat.collapse') : $t('chat.expand') }}</span>
              </div>
              <img src="@/assets/icons/icon_g.png" alt="" v-if="selectedAppId != defaultAppId" @click="clearAppSelection">
            </div>
          </div>
          <div class="tab-content" v-show="isTabContentOpen">
            <div class="item" v-for="item in appContent" :key="item.id" @click="selectApp(item)" :class="{ selected: selectedAppId === item.id }">
              <img :src="item.img" alt="">
              <a-tooltip>
                <template slot="title">
                  {{ item.name }}
                </template>
                <div class="headline">{{ item.name }}</div>
              </a-tooltip>
              <a-tooltip placement="bottom">
                <template slot="title">
                  {{ item.desc }}
                </template>
                <div class="desc">{{ item.desc }}</div>
              </a-tooltip>
            </div>
          </div>
        </div>
        <div class="attach" v-if="percent > 0">
          <div class="link" v-if="fileData.type === 'link'">
            <a-input :placeholder="$t('chat.enterLink')" size="small" v-model="fileData.url" style="width: 300px;"></a-input>
            <img src="@/assets/icons/ai_close_link.png" class="close" @click.stop="closeUpload" alt="">
          </div>
          <div class="doc" @click="openUpload" v-else>
            <img :src="blobURL" v-if="fileData.type === 'image'" alt="">
            <img :src="getFileIcon(uploadedFileName)" v-else alt="">
            <div class="detail">
              <div class="title">{{ uploadedFileName }}</div>
              <div class="desc" v-if="percent === 100">{{ uploadedFileSize }}</div>
              <div class="desc" v-else>{{ $t('chat.transferring') }}{{ uploadSpeed }} {{ percent }}%</div>
            </div>
            <img v-if="percent === 100" src="@/assets/icons/ai_close.png" class="close" @click.stop="closeUpload" alt="">
            <div v-else class="cancel" @click.stop="cancelUpload">{{ $t('chat.cancel') }}</div>
          </div>
        </div>
        <div class="custom-input">
          <div class="custom-input-area" contenteditable="true" @input="onCustomInputAreaInput" ref="customInputArea" @keydown="onKeydown" :placeholder="richPlaceholder" @paste="handlePaste">
          </div>
        </div>
        <div class="function">
          <div class="left">
            <div :class="{ disabled: searchSwitch }" v-if="selectedAppId == defaultAppId && !hideApp" @click="selectKnowledge">
              <div>
                <img src="@/assets/icons/icon_zs.png" alt="">
              </div>
              <span>{{ knowledgeData.name || $t('chat.knowledgeBase') }}</span>
              <img src="@/assets/icons/xl.png" alt="">
              <div @click.stop class="switch">
                <a-switch size="small" v-model="knowledgeSwitch" :disabled="searchSwitch" />
              </div>
            </div>
            <div :class="{ disabled: knowledgeSwitch }" v-if="selectedAppId == defaultAppId && !hideApp">
              <div>
                <img src="@/assets/icons/icon_lw.png" alt="">
              </div>
              <span>{{ $t('chat.webSearch') }}</span>
              <div @click.stop class="switch">
                <a-switch size="small" v-model="searchSwitch" :disabled="knowledgeSwitch" />
              </div>
            </div>
          </div>
          <div class="right">
            <a-tooltip overlayClassName="ai-tooltip">
              <template #title>
                <div class="ai-tooltip-content">
                  <p style="margin: 0; font-weight: bold;">{{ $t('chat.uploadFile') }}</p>
                  <span>{{ $t('chat.fileLimit') }}</span>
                  <span>{{ $t('chat.supportedDocFormats') }}</span>
                </div>
              </template>
              <div @click="$refs.fileInput.click()" class="list">
                <input type="file" accept=".pdf,.docx,.txt,.xls,.xlsx" ref="fileInput" style="display:none" @change="e => handleFileChange(e, 'document')" />
                <img src="@/assets/icons/icon_wj.png" alt="">
              </div>
            </a-tooltip>
            <a-tooltip overlayClassName="ai-tooltip">
              <template #title>
                <div class="ai-tooltip-content">
                  <p style="margin: 0; font-weight: bold;">{{ $t('chat.uploadImage') }}</p>
                  <span>{{ $t('chat.imageLimit') }}</span>
                  <span>{{ $t('chat.supportedImageFormats') }}</span>
                </div>
              </template>
              <div @click="$refs.imgInput.click()" class="list">
                <input type="file" accept=".jpg,.jpeg,.png" ref="imgInput" style="display:none" @change="e => handleFileChange(e, 'image')" />
                <img src="@/assets/icons/icon_tp.png" alt="">
              </div>
            </a-tooltip>
            <a-tooltip overlayClassName="ai-tooltip">
              <template #title>
                <div class="ai-tooltip-content">
                  <p style="margin: 0; font-weight: bold;">{{ $t('chat.uploadLink') }}</p>
                  <span>{{ $t('chat.linkDescription') }}</span>
                </div>
              </template>
              <div @click="fileData.type='link';percent=100" class="list">
                <img src="@/assets/icons/icon_lj.png" alt="">
              </div>
            </a-tooltip>
            <div class="send">
              <img v-if="isInputEmpty || isGenerating || uploadedFileIng" src="@/assets/icons/icon_a_n.png" alt="">
              <img v-else @click="sendMessage()" style="cursor: pointer;" src="@/assets/icons/icon_bu.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="history" @click="goHistory">{{ $t('chat.historyButton') }}</div>
      <img v-if="messages.length !== 0" :src="require(`@/assets/${this.$i18n.locale}/ai_new.png`)" class="newChat" @click="newChat" alt="">
    </div>
    <ZskModal ref="zskModal" @select="selectKnowledgeConfirm" />
  </div>
</template>

<script>
import ZskModal from '@/components/CourseGenerationConfig/ZskModal.vue'
import { SSE } from '@/utils/sse.js'
import cookie from 'js-cookie'
import { getAIChatHistoryDetail, uploadFile } from '@/api/aiApp.js'
import axios from 'axios'
import { Document, Packer, Paragraph } from 'docx'
import { app, baseApp } from '@/data/app.js'
const defaultAppId = baseApp.id

export default {
  name: 'Chat',
  components: {
    ZskModal
  },
  props: {
    // 隐藏app的选择。
    hideApp: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      schoolName: cookie.getJSON('user_infor').schoolName,
      userName: '',
      app,
      appContent: [],
      selectedTabIndex: -1,
      messageInput: [],
      selectedAppId: defaultAppId,
      defaultAppId,
      isTabContentOpen: false,
      knowledgeSwitch: false,
      knowledgeData: {},
      searchSwitch: false,
      messages: [], // 用于存储消息记录
      isInputEmpty: true,
      isGenerating: false, // 控制是否正在生成回答
      connecting: false,
      uploadSpeed: '',
      percent: 0,
      tipList: [
        {
          img: require('@/assets/icons/icon_pdf.png'),
          desc: 'pdf'
        },
        {
          img: require('@/assets/icons/icon_word.png'),
          desc: 'doc、docx、txt'
        },
        {
          img: require('@/assets/icons/icon_ppt.png'),
          desc: 'ppt、pptx'
        },
        {
          img: require('@/assets/icons/icon_xlsx.png'),
          desc: 'xls、xlsx'
        },
        {
          img: require('@/assets/icons/icon_tupian.png'),
          desc: 'gif、jpeg、png、jpg'
        }
      ],
      uploadedFileSize: '',
      fileData: {
        type: '',
        file: null,
        fileName: '',
        fileSize: ''
      },
      files: [],
      blobURL: '',
      playingMessageId: null,
      conversationId: '', // 用于存储会话 ID
      customInputAreaHtml: '', // 新增：用于同步内容
      uploadedFileIng: false,
      uploadedFileId: '',
      uploadedFileName: ''
    }
  },
  computed: {
    richPlaceholder() {
      let data = ''
      if (this.searchSwitch) {
        data = this.$t('chat.placeholderWithSearch')
      } else if (this.selectedTabIndex > -1 && !this.hideApp && this.selectedAppId === this.defaultAppId) {
        data = this.$t('chat.placeholderWithTemplate')
      } else {
        data = this.$t('chat.placeholderDefault')
      }
      return data
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    // 选择app的tab
    selectedTab(index) {
      this.selectedTabIndex = index
      this.appContent = this.app[index].children
      this.isTabContentOpen = true
      this.konwledgeSwitch = false
      this.searchSwitch = false
    },
    // 选择app
    selectApp(item, config = {}) {
      if (item.type === 'course') {
        this.$router.push({
          path: '/courses/generationCourse'
        })
        return
      } else if (item.type === 'teachingPlan') {
        this.$router.push({
          path: '/AI/chat/teaching-plan'
        })
        return
      }
      this.selectedAppId = item.id
      this.messageInput = item.content
      this.conversationId = config.conversationId || ''
      this.closeUpload()
    },
    selectAppById(id) {
      // 使用for...of循环,找到app后即可break
      for (let i = 0; i < this.app.length; i++) {
        const findApp = this.app[i].children.find(app => app.id === id)
        if (findApp) {
          this.selectApp(findApp, {
            conversationId: this.conversationId
          })
          this.selectedTab(i)
          break
        }
      }
    },
    // 清除app选择
    clearAppSelection() {
      this.selectedTabIndex = -1
      this.selectedAppId = defaultAppId
      this.conversationId = ''
      this.clearInput()
    },
    // 清除发送的数据
    clearInput() {
      this.isTabContentOpen = false
      this.messageInput = []
      this.checkInputEmpty()
    },
    newChat() {
      this.messages = []
      if (this.hideApp) {
        this.clearInput()
      } else {
        this.clearAppSelection()
      }
      // 去掉地址栏中的参数
      this.$router.replace({
        path: this.$route.path,
        query: {
          id: this.hideApp ? this.$route.query.id : ''
        }
      })
    },

    // 输入中的内容处理
    onKeydown(e) {
      console.log(e, e.key)
      const selection = window.getSelection();
      if (!selection || !selection.anchorNode) return;

      const node = selection.anchorNode;
      const parent = node.nodeType === 3 ? node.parentElement : node; // 如果是文本节点，取 parentElement

      // 处理 Enter 键和 Shift+Enter 组合键
      if (e.key === 'Enter') {
        // 如果按下了 Shift 键，则允许换行
        if (e.shiftKey) {
          // 允许默认行为（插入换行符）
          return
        } else {
          // 阻止默认的换行行为
          e.preventDefault()
          // 检查输入是否为空
          this.checkInputEmpty()
          // 如果输入不为空且不在生成回答中，则发送消息
          if (this.isInputEmpty) {
            this.$message.warning(this.$t('chat.pleaseEnterContent'))
          } else if (this.isGenerating) {
            this.$message.warning(this.$t('chat.generatingAnswer'))
          } else if (this.uploadedFileIng) {
            this.$message.warning(this.$t('chat.uploadingFile'))
          } else {
            // 发送消息
            this.sendMessage()
          }
          return
        }
      }

      // 如果当前光标在 span 中，并且内容快删完了
      if (
        parent.tagName === 'SPAN' &&
        (e.key === 'Backspace' || e.key === 'Delete') &&
        parent.textContent.trim().length == 1 && 
        parent.textContent === '\u200B'
      ) {
        
      } else if (
        parent.tagName === 'SPAN' &&
        (e.key === 'Backspace' || e.key === 'Delete') &&
        parent.textContent.trim().length <= 1
      ) {
        e.preventDefault();
        parent.textContent = '\u200B'; // 阻止被删除
      }

      // 处理 customInputAreaHtml 下属 span 内容为零宽空格的情况
      const spans = document.querySelectorAll('.custom-input-area span')
      spans.forEach(span => {
        if (span.innerHTML === '\u200B' || span.innerHTML === '&ZeroWidthSpace;') {
          span.parentNode.removeChild(span)
        }
      })
    },
    // onInput(e) {
    //   const el = e.target;
    //   if (el.textContent === '') {
    //     el.innerHTML = '\u200B'; // 添加零宽空格防止被删除
    //   }
    // },
    // 输入中的内容处理
    onCustomInputAreaInput(e) {
      this.customInputAreaHtml = e.target.innerHTML
      // 处理 cs-custom-input-1 的 <br>
      const customSpan = document.getElementById('cs-custom-input-1')
      if (customSpan && (customSpan.innerHTML === '<br>' || customSpan.innerHTML === '<br _v3="">')) {
        customSpan.innerHTML = ''
      }
      // 处理 class custom-input-area 的 <br>
      const customInputArea = document.querySelector('.custom-input-area')
      if (customInputArea && (customInputArea.innerHTML === '<br>' || customInputArea.innerHTML === '<br _v3="">')) {
        customInputArea.innerHTML = ''
      }

      // 处理 custom-input-area 下面dom元素中直接写在dom上的style
      const customInputAreaSpans = document.querySelectorAll('.custom-input-area span')
      customInputAreaSpans.forEach(span => {
        if (span.style && span.style.display === 'none') {
          span.parentNode.removeChild(span)
        }
      })

      this.checkInputEmpty()
    },
    handlePaste(e) {
      e.preventDefault()
      const text = (e.clipboardData || window.clipboardData).getData('text/plain')

      // 插入纯文本到当前光标位置
      const selection = window.getSelection()
      if (!selection.rangeCount) return

      const range = selection.getRangeAt(0)
      range.deleteContents()
      range.insertNode(document.createTextNode(text))

      // 将光标移到插入文本之后
      range.collapse(false)
      selection.removeAllRanges()
      selection.addRange(range)

      this.checkInputEmpty()
    },

    // 发送消息
    async sendMessage(again = false, answerData = null) {
      let params
      let userMessage
      if (again) {
        params = answerData.sendData
        userMessage = answerData.askData
      } else {
        // 拼接 custom-input-area 内所有文本和 input 的值
        let customInputText = ''
        if (this.$refs.customInputArea) {
          const area = this.$refs.customInputArea
          const traverse = function(node) {
            if (node.nodeType === Node.TEXT_NODE) {
              customInputText += node.textContent
            } else if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.tagName === 'INPUT') {
                customInputText += node.value
              } else {
                for (let child of node.childNodes) {
                  traverse(child)
                }
              }
            }
          }
          traverse(area)
        }
        // 你可以根据需要将 customInputText 作为消息内容或参数传递
        if (!customInputText.trim()) return

        const attach = this.fileData.type ? [{
            type: this.fileData.type,
            name: this.uploadedFileName,
            size: this.uploadedFileSize,
            url: this.fileData.type === 'link' ? this.fileData.url : this.blobURL
          }] : []
        userMessage = {
          id: Date.now(), // 临时 ID
          text: customInputText,
          attach,
          type: 'ask'
        }

        const query = customInputText
        // 准备请求参数
        params = {
          query: query,
          response_mode: 'streaming',
          conversation_id: this.conversationId || undefined,
          inputs: {
            is_searxng: this.searchSwitch ? 'T' : 'F',
            knowledge_id: this.knowledgeSwitch ? this.knowledgeData.id : '',
            user_url: this.fileData.url, // 用户输入的 URL
            upload_images: this.fileData.type === 'image' ? 'T' : 'F' // 是否上传图片
          },
          files: this.files // 上传的文件。图片或者文档
        }
      }

      this.messages.push(userMessage)

      // 创建一个临时消息用于显示AI正在输入的状态
      const tempMessage = {
        id: Date.now(),
        text: '',
        attach: [],
        showSourceDetail: true,
        type: 'answer',
        askData: userMessage,
        sendData: params
      }
      this.messages.push(tempMessage)

      this.source = new SSE('/ai_app/chat-messages', {
        headers: {
          'X-App-Id': this.selectedAppId
        },
        payload: JSON.stringify(params),
        method: 'POST'
      })
      this.source.addEventListener('message', e => {
        const res = JSON.parse(e.data)
        console.log(res)
        if (res.event === 'message') {
          this.connecting = false
          tempMessage.text += res.answer.replace(/[#*]/g, '')
          if (res.conversation_id) {
            this.conversationId = res.conversation_id
          }
        } else if (res.event === 'message_end') {
          this.isGenerating = false
          if (res.metadata.retriever_resources) {
            const attach = []
            res.metadata.retriever_resources.forEach(item => {
              if (attach.findIndex(itemAttach => itemAttach.document_id === item.document_id) === -1) {
                attach.push({
                  document_id: item.document_id,
                  text: item.document_name.split('^')[1]
                })
              } else {
                // const findIndex = attach.findIndex(itemAttach => itemAttach.document_id === item.itemAttach)
                // attach[findIndex].content = item.content
              }
            })
            tempMessage.attach = attach
          }
        } else if (res.event === 'error') {
          this.connecting = false
          this.isGenerating = false
          tempMessage.text = this.$t('chat.systemTimeout')
        }
      })
      this.source.addEventListener('error', event => {
        this.connecting = false
        this.isGenerating = false
      })
      this.connecting = true
      this.isGenerating = true
      this.clearInput()
      this.closeUpload()
    },

    // 停止生成回答
    async stopGeneration(message) {
      if (this.source) {
        this.isGenerating = false
        this.source.close()
        message.isStop = true
      }
    },
    // 坚持输入内容是否为空
    checkInputEmpty() {
      // 获取输入区域的内容
      const content = this.$refs.customInputArea.textContent.trim()
      // 设置一个标志表示内容是否为空
      this.isInputEmpty = content === ''
    },
    // 自动滚动到底部
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.chatContainer
        if (container) {
          console.log(container)
          container.scrollTop = container.scrollHeight
        }
      })
    },
    // 播放回答
    playAnswer(message) {
      if (!message.text) return
    // 如果当前消息正在播放，则停止播放
      if (this.playingMessageId === message.id) {
        window.speechSynthesis.cancel()
        this.playingMessageId = null
        return
      }
      // 如果有其他消息正在播放，先停止它
      if (this.playingMessageId) {
        window.speechSynthesis.cancel()
      }
      // 开始播放当前消息
      const utter = new window.SpeechSynthesisUtterance(message.text)
      this.playingMessageId = message.id
      // 监听播放结束事件
      utter.onend = () => {
        this.playingMessageId = null
      }
      window.speechSynthesis.speak(utter)
    },
    // 复制回答
    copyAnswer(message) {
      if (!message.text) return
      if (navigator.clipboard) {
        navigator.clipboard.writeText(message.text)
        this.$message.success(this.$t('chat.copiedToClipboard'))
      } else {
        // 兼容旧浏览器
        const textarea = document.createElement('textarea')
        textarea.value = message.text
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        this.$message.success(this.$t('chat.copiedToClipboard'))
      }
    },
    // 下载回答
    downloadAnswer(message) {
      // if (!message.text) return
      // // 生成最基础的 Word 文档内容
      // const header = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><w:wordDocument xmlns:w="http://schemas.microsoft.com/office/word/2003/wordml"><w:body><w:p><w:r><w:t>'
      // const footer = '</w:t></w:r></w:p></w:body></w:wordDocument>'
      // const content = header + message.text.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '</w:t></w:r></w:p><w:p><w:r><w:t>') + footer
      // const blob = new Blob([content], { type: 'application/msword' })
      // const url = window.URL.createObjectURL(blob)
      // const a = document.createElement('a')
      // a.href = url
      // a.download = '智能问答.doc'
      // document.body.appendChild(a)
      // a.click()
      // document.body.removeChild(a)
      // window.URL.revokeObjectURL(url)
      if (!message.text) return
      const content = message.text.split('\n')

      // 创建 Document 对象
      const doc = new Document({
        sections: [
          {
            children: content.map((item, index) => {
              return new Paragraph(item)
            })
          }
        ]
      })

      // 导出为 Blob，并触发下载
      Packer.toBlob(doc).then((blob) => {
        const blobUrl = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = blobUrl
        link.download = this.$t('chat.aiAnswerFilename')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(blobUrl)
      })
    },
    // 重新发送消息
    regenerateAnswer(message) {
      // 这里根据你的业务逻辑实现重新生成
      this.sendMessage(true, message)
    },
    selectKnowledge() {
      if (this.searchSwitch) return
      console.log(this.knowledgeData)
      this.$refs.zskModal.showModal()
      this.$refs.zskModal.selectedRowKeys = [this.knowledgeData.id]
    },
    selectKnowledgeConfirm(data) {
      this.knowledgeData = data || {}
    },
    // 上传文件
    async handleFileChange(e, type) {
      const file = e.target.files[0]
      if (!file) {
        this.fileData.type = ''
        return
      }
      this.fileData.type = type
      this.uploadedFileIng = true
      try {
        this.blobURL = URL.createObjectURL(file)
        this.uploadedFileName = file.name
        // 创建一个新的取消令牌源
        this.uploadCancelSource = axios.CancelToken.source()
        let lastTime = Date.now()
        let lastLoaded = 0
        const res = await uploadFile({ file }, {
          'X-App-Id': this.selectedAppId
        }, (progressEvent) => {
          const realPercent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          )
          this.percent = realPercent === 100 ? 99 : realPercent

          const currentTime = Date.now()
          const timeDiff = (currentTime - lastTime) / 1000 // 秒
          const loadedDiff = progressEvent.loaded - lastLoaded // 字节

          if (timeDiff > 0) {
            const speed = loadedDiff / timeDiff // B/s
            this.uploadSpeed = this.formatSpeed(speed)
          }

          lastTime = currentTime
          lastLoaded = progressEvent.loaded
          console.log(`上传进度：${this.percent}%。速率：${this.uploadSpeed}`)
        }, this.uploadCancelSource.token)
        this.percent = 100
        this.uploadedFileId = res.id
        this.uploadedFileSize = this.formatFileSize(res.size) // res.size
        Object.assign(this.fileData, res)
        console.log(this.fileData)
        this.files = [{
          type: this.fileData.type,
          transfer_method: 'local_file',
          upload_file_id: res.id
        }]
        this.$message.success(this.$t('chat.fileUploadSuccess'))
      } catch (err) {
        this.closeUpload()
        console.log(err)
        this.$message.error(this.$t('chat.fileUploadFailed'))
      }
      this.uploadedFileIng = false
    },
    // 取消文件上传请求
    cancelUpload() {
      this.uploadCancelSource.cancel(this.$t('chat.userCancelledUpload'))
      this.percent = 0
      this.uploadSpeed = ''
      this.uploadedFileId = ''
      this.uploadedFileName = ''
      this.uploadedFileSize = ''
      this.fileData = {}
      this.files = []
      // this.$message.warning(this.$t('chat.uploadCancelled'))
    },
    // 去掉上传的文件
    closeUpload() {
      this.percent = 0
      this.uploadSpeed = ''
      this.uploadedFileId = ''
      this.uploadedFileName = ''
      this.uploadedFileSize = ''
      this.fileData = {}
      this.files = []
      // this.$message.success(this.$t('chat.fileDeleted'))
    },
    formatSpeed(bytesPerSecond) {
      if (bytesPerSecond >= 1024 * 1024) {
        return (bytesPerSecond / 1024 / 1024).toFixed(2) + ' ' + this.$t('chat.speedUnit.mbps')
      } else if (bytesPerSecond >= 1024) {
        return (bytesPerSecond / 1024).toFixed(2) + ' ' + this.$t('chat.speedUnit.kbps')
      } else {
        return bytesPerSecond.toFixed(2) + ' ' + this.$t('chat.speedUnit.bps')
      }
    },
    // 格式化文件大小
    formatFileSize(bytes) {
      if (bytes >= 1024 * 1024 * 1024) {
        return (bytes / 1024 / 1024 / 1024).toFixed(2) + this.$t('chat.sizeUnit.gb')
      } else if (bytes >= 1024 * 1024) {
        return (bytes / 1024 / 1024).toFixed(2) + this.$t('chat.sizeUnit.mb')
      } else if (bytes >= 1024) {
        return (bytes / 1024).toFixed(2) + this.$t('chat.sizeUnit.kb')
      }
    },
    getFileIcon(fileName) {
      const fileExtension = fileName.split('.').pop().toLowerCase()
      const fileType = this.tipList.find(item => item.desc.includes(fileExtension))
      return fileType ? fileType.img : ''
    },
    openUpload() {
      window.open(this.blobURL, '_blank')
    },
    goHistory() {
      console.log(this.selectedAppId)
      this.$router.push({
        path: '/ai/chat/history',
        query: {
          id: this.selectedAppId
        }
      })
    },
    getUserName() {
      return cookie.getJSON('user_infor').name.substr(0, 1)
    },
    async getHistoryDetail() {
      const res = await getAIChatHistoryDetail({
        conversation_id: this.conversationId,
        first_id: null,
        limit: 20
      }, {
        'X-App-Id': this.selectedAppId
      })
      this.messages = []
      for (let i = 0; i < res.data.length; i++) {
        const item = res.data[i]
        const userMessage = {
          id: item.id, // 临时 ID
          text: res.data[i].query,
          attach: item.message_files.map(file => {
            return {
              type: file.type,
              name: file.filename,
              size: file.size,
              url: file.url
            }
          }),
          type: 'ask'
        }
        this.messages.push(userMessage)
        const attach = []
        if (item.retriever_resources) {
          item.retriever_resources.forEach(itemResources => {
            if (attach.findIndex(itemAttach => itemAttach.document_id === itemResources.document_id) === -1) {
              attach.push({
                document_id: itemResources.document_id,
                text: itemResources.document_name.split('^')[1]
              })
            } else {
              // const findIndex = attach.findIndex(itemAttach => itemAttach.dataset_id === item.itemAttach)
              // attach[findIndex].content = item.content
            }
          })
        }
        const tempMessage = {
          id: item.id,
          text: item.answer.replace(/[#*]/g, ''),
          attach,
          type: 'answer',
          askData: userMessage,
          showSourceDetail: true,
          sendData: {
            query: item.query,
            response_mode: 'streaming',
            conversation_id: this.conversationId || undefined,
            inputs: item.inputs,
            files: item.message_files
          }
        }
        this.messages.push(tempMessage)
      }
      this.historyDetail = res
      this.messageInput = []
      this.selectAppById(this.$route.query.id) // 解决app默认文案被覆盖的问题
      this.isTabContentOpen = false
    }
  },
  watch: {
    messageInput: {
      handler(newVal) {
        // 确保DOM已经准备好
        this.$nextTick(() => {
          const inputArea = this.$refs.customInputArea
          if (!inputArea) return
          
          // 清空现有内容
          while (inputArea.firstChild) {
            inputArea.removeChild(inputArea.firstChild)
          }
          
          // 根据messageInput重新创建DOM元素
          newVal.forEach((item, index) => {
            const span = document.createElement('span')
            span.textContent = item.text || ''
            
            if (item.placeholder) {
              span.setAttribute('placeholder', item.placeholder)
              span.classList.add('input-custom-placeholder', 'input-custom-item')
              span.setAttribute('contenteditable', 'true')
            }
            
            // 为了保持与Vue模板中相同的key，可以设置一个自定义属性
            span.setAttribute('data-key', `${this.selectedAppId}-${index}`)
            
            inputArea.appendChild(span)
          })

          this.checkInputEmpty()
        })
      },
      deep: true // 深度监听，确保数组内对象属性变化也能触发
    },
    messages: {
      handler() {
        this.scrollToBottom()
      },
      deep: true
    },
    isGenerating(val) {
      if (val) {
        this.scrollToBottom()
      }
    }
  },
  mounted() {
    this.userName = this.getUserName()
  },
  activated() {
    this.id = this.$route.query.id
    if (this.id) { // 存在id代表有应用
      this.selectedAppId = this.id || defaultAppId
      this.selectAppById(this.id)
      this.conversationId = this.queryConversationId = this.$route.query.conversationId
      if (this.conversationId) { // 存在会话id代表有历史记录
        this.getHistoryDetail()
      }
    } else {

    }
  },
  deactivated() {
    if (this.id) {
      this.messages = []
      this.clearAppSelection()
    }
  }
}
</script>

<style scoped lang="less">
.chat-container{
  padding-top: 20px;
  .back{
    width: fit-content;
    border-radius: 20px;
    margin-left: 19px;
    background: none;
    &:hover{
      color: rgba(0, 0, 0, 0.65);
      border-color: rgb(217, 217, 217);
    }
  }
  .active {
    box-shadow: none;
    width: 120px;
  }
  .default {
    box-shadow: none;
    width: 120px;
    background: #edf3fa;
    color: #6b738c !important;
  }
  > .chat-container-inner{
    width: 100%;
    height: 100%;
    position: relative;
    margin: 0 auto;
    .chat{
      width: 100%;
      height: calc(100vh - 380px);
      overflow-y: auto;
      > div{
        width: 80%;
        display: flex;
        margin: 0 auto;
        .left{
          width: 5%;
          padding-right: 16px;
          img{
            width: 42px;
            height: 42px;
            margin-top: 10px;
            float: right;
          }
        }
        .middle{
          width: 90%;
          > div > div{
            margin-bottom: 12px;
          }
          .ask{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            padding-top: 10px;
            .attach{
              width: fit-content;
              height: 55px;
              background: #F7F7F7;
              border-radius: 4px;
              display: flex;
              align-items: center;
              padding: 0 30px 0 18px;
              margin-bottom: 12px;
              img{
                width: 20px;
                margin-right: 15px;
              }
              > div{
                .title{
                  font-weight: 400;
                  font-size: 16px;
                  color: #000000;
                  line-height: 22px;
                }
                .size{
                  font-weight: 400;
                  font-size: 12px;
                  color: #999999;
                  line-height: 18px;
                  margin-top: 4px;
                }
              }
            }
            .ask-input{
              background: #F1F4F6;
              border-radius: 13px;
              padding: 12px 16px;
              margin-bottom: 12px;
              white-space: pre-line;
            }
          }
          .answer{
            width: 100%;
            height: 100%;
            padding-top: 10px;
            .connecting{
              width: 42px;
              height: 42px;
            }
            .answer-content{
              font-size: 16px;
              color: #000000;
              margin-bottom: 17px;
              white-space: pre-line;
              padding-top: 10px;
            }
            .attach{
              .info{
                display: flex;
                align-items: center;
                span{
                  font-weight: 400;
                  font-size: 14px;
                  color: #616D8D;
                  line-height: 20px;
                }
                img{
                  width: 14px;
                  height: 8px;
                  margin-left: 10px;
                  cursor: pointer;
                  transition: transform 0.2s;
                }
              }
              .detail{
                width: 100%;
                height: 100%;
                background: #F6F7F9;
                border-radius: 6px;
                padding: 15px 11px;
                margin-top: 20px;
                > div{
                  margin-bottom: 6px;
                }
              }
            }
            .stop{
              min-width: 80px;
              width: fit-content;
              padding: 0 12px;
              height: 30px;
              border-radius: 15px;
              border: 1px solid #B5C5DA;
              margin-bottom: 12px;
              font-weight: 600;
              font-size: 12px;
              color: #678BB8;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .stop-text{
              font-weight: 600;
              font-size: 12px;
              color: #9E9E9E;
              padding-bottom: 17px;
            }
            .operation{
              display: flex;
              .list{
                width: 16px;
                height: 16px;
                margin-right: 20px;
                cursor: pointer;
                overflow: hidden;
                img{
                  display: block;
                  width: 100%;
                  height: 100%;
                }
              }
              .list:hover{
                img{
                  transform: translateY(-60px);
                  filter: drop-shadow(#FF9E3F 0 60px);
                }
              }
            }
          }
        }
        .right{
          width: 5%;
          padding-left: 16px;
          div{
            width: 42px;
            height: 42px;
            margin-top: 10px;
            background: #E7F0F9;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 600;
            font-size: 18px;
            color: #8F9AAE;
          }
        }
      }
    }
    > .title{
      margin-top: calc(100vh - 540px);
      margin-left: 14%;
      padding-left: 24px;
      div:nth-child(1){
        font-weight: 600;
        font-size: 28px;
        color: #000000;
        line-height: 40px;
      }
      div:nth-child(2){
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        line-height: 20px;
        margin-top: 8px;
      }
    }
    .messages{
      position: absolute;
      bottom: 28px;
      left: 14%;
      width: 72%;
      background: #FFFFFF;
      box-shadow: 0px 0px 16px -9px rgba(0,0,0,0.29);
      border-radius: 24px;
      border: 1px solid #E7E7E7;
      padding: 19px 24px;
      background: #FFFFFF;
      .app{
        border-bottom: 1px solid #EDEDED;
        .header{
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          .tab{
            display: flex;
            align-items: center;
            flex: 1;
            .tab-item{
              width: 75px;
              height: 40px;
              border-radius: 12px;
              border: 1px solid #EDEDED;
              font-weight: 400;
              font-size: 14px;
              color: #000000;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-right: 8px;
              cursor: pointer;
            }
            .selected{
              color: #fff;
              background: linear-gradient( 210deg, #FF9E3F 0%, #FF6203 100%);
            }
          }
          .operation{
            display: flex;
            align-items: center;
            > div{
              display: flex;
              align-items: center;
              position: relative;
              cursor: pointer;
              font-size: 12px;
              img{
                width: 13px;
                height: 13px;
                margin-right: 4px;
              }
            }
            .selectedApp{
              margin-right: 26px;
              &::after{
                content: '';
                width: 1px;
                height: 16px;
                background: #EDEDED;
                position: absolute;
                right: -13px;
              }
            }
            > img{
              width: 12px;
              height: 12px;
              margin-right: 4px;
              cursor: pointer;
            }
          }
        }
        .tab-content{
          margin-top: 20px;
          display: flex;
          flex-wrap: wrap;
          padding-bottom: 10px;
          .item{
            width: 22%;
            margin-right: 4%;
            height: 110px;
            border-radius: 12px;
            border: 1px solid #EDEDED;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 13px 19px;
            cursor: pointer;
            margin-bottom: 12px;
            transition: all 0.3s ease;
            img{
              width: 27px;
              height: 27px;
            }
            .headline{
              font-weight: 700;
              font-size: 14px;
              color: #000000;
              line-height: 20px;
              margin-top: 14px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .desc{
              font-weight: 400;
              font-size: 12px;
              color: #000000;
              line-height: 17px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .item:hover {
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
            transform: translateY(-2px);
            cursor: pointer; /* 鼠标悬停时显示手型 */
            .headline{
              color: #FF6506;
            }
          }
          .item:nth-child(4n){
            margin-right: 0;
          }
          .item.selected {
            border: 1px solid #FF6506;
            .headline{
              color: #FF6506;
            }
          }
        }
      }
      .attach{
        display: flex;
        align-items: center;
        margin-top: 18px;
        .doc{
          height: 42px;
          background: #F5F7FA;
          border-radius: 4px;
          padding: 9px;
          display: flex;
          align-items: center;
          position: relative;
          cursor: pointer;
          > img:first-child{
            width: 20px;
            height: 24px;
            margin-right: 9px;
          }
          .title{
            font-weight: 400;
            font-size: 10px;
            color: #000000;
          }
          .desc{
            font-weight: 400;
            font-size: 8px;
            color: #999999;
          }
          .cancel{
            font-weight: 400;
            font-size: 8px;
            color: #F27529;
            padding-left: 20px;
            cursor: pointer;
          }
          .close{
            width: 14px;
            height: 14px;
            cursor: pointer;
            position: absolute;
            right: -4px;
            top: -4px;
          }
        }
        .link{
          position: relative;
          input{
            width: 227px;
            height: 31px;
            background: #FFF9F2;
            border-radius: 16px;
            border: none;
            padding-left: 10px;
            font-size: 12px;
            &::placeholder{
              font-weight: 400;
              font-size: 14px;
              color: #FF5800;
              font-size: 12px;
            }
          }
          .close{
            width: 14px;
            height: 14px;
            cursor: pointer;
            position: absolute;
            right: -2px;
            top: -2px;
          }
        }
      }
      .custom-input{
        padding: 12px 0;
      }
      /deep/ .custom-input-area {
        background: transparent;
        margin-bottom: 0;
        width: 100%;
        position: relative;
        word-wrap: break-word;
        cursor: text;
        text-align: left;
        white-space: pre-wrap;
        outline: none;
        max-height: 236px;
        min-height: 78px;
        overflow-x: hidden;
        overflow-y: auto;
        &:after {
          font-size: 14px;
          color: #999999;
          content: attr(placeholder);
        }
        &:not(:empty):after {
          content: none;
        }
        .input-custom-item {
          // background-color: rgba(110, 75, 250, .09);
          // border-radius: 9px;
          color: #2B5982;
          display: inline-block;
          line-height: 28px;
          // max-width: calc(100% - 27px);
          // padding: 0 8px;
        }
        .input-custom-placeholder:after {
          color: #6693BC;
          content: attr(placeholder);
        }
        .input-custom-placeholder:not(:empty):after {
          content: none;
        }
        // .input-custom-placeholder:empty::after {
        //   content: attr(placeholder);
        //   color: #999;
        //   pointer-events: none;
        // }
        .tag {
          background: #e6eaff;
          color: #6c7ae0;
          border-radius: 8px;
          padding: 2px 10px;
          margin: 0 4px;
          cursor: pointer;
          font-weight: 700;
          font-size: 15px;
        }
        .button-group {
          display: flex;
          align-items: center;
          margin-left: 12px;
          .input-btn {
            margin-right: 8px;
            background: #f0f2ff;
            color: #6c7ae0;
            border: none;
            font-size: 14px;
            border-radius: 8px;
            padding: 0 12px;
            height: 32px;
            min-width: 100px;
            box-shadow: 0 2px 8px 0 rgba(44,59,77,0.04);
          }
        }
        .send-btn {
          margin-left: auto;
          background: linear-gradient(90deg, #6c7ae0 0%, #8e9fff 100%);
          color: #fff;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          border: none;
          box-shadow: 0 2px 8px 0 rgba(44,59,77,0.08);
          transition: background 0.3s;
        }
        .send-btn:hover {
          background: linear-gradient(90deg, #8e9fff 0%, #6c7ae0 100%);
        }
        .arrow-up {
          font-size: 20px;
        }
      }
      .function{
        width: 100%;
        display: flex;
        .left{
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          > div{
            min-width: 120px;
            height: 31px;
            background: #F5F5F9;
            border-radius: 16px;
            display: flex;
            align-items: center;
            padding: 0 11px;
            margin-right: 10px;
            > div:nth-child(1){
              width: 14px;
              height: 14px;
              margin-right: 4px;
              overflow: hidden;
              img{
                width: 100%;
                height: 100%;
                display: block;
              }
            }
            > span{
              font-weight: 400;
              font-size: 12px;
              color: #000000;
            }
            > img:nth-child(3){
              width: 8px;
              height: 5px;
              margin-left: 6px;
            }
            .switch{
              margin-left: 10px;
              margin-top: -2px;
              /deep/ .ant-switch:not(.ant-switch-checked){
                background: #D1D1D1;
              }
            }
          }
          .disabled{
            cursor: not-allowed;
            div:first-child{
              img{
                transform: translateY(-60px);
                filter: drop-shadow(#9C9B9B 0 60px);
              }
            }
            span{
              color: #9C9B9B;
            }
          }
        }
       .right{
         display: flex;
         align-items: center;
          > .list{
            overflow: hidden;
            cursor: pointer;
            margin-left: 15px;
            width: 29px;
            height: 29px;
            display: flex;
            align-items: center;
            justify-content: center;
            > img{
              width: 20px;
              height: 18px;
              cursor: pointer;
            }
            &:hover{
              background: #F3F3F3;
              border-radius: 50%;
              img{
                transform: translateY(-60px);
                filter: drop-shadow(#767676 0 60px);
              }
            }
          }
          > .send{
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-left: 35px;
            position: relative;
            overflow: inherit;
            &::after{
              content: '';
              width: 1px;
              height: 20px;
              background: #EDEDED;
              position: absolute;
              left: -15px;
              top: 50%;
              transform: translateY(-50%);
            }
            img{
              width: 100%;
              height: 100%;
              display: block;
              margin-left: 0;
            }
          }
       }
      }
    }
    .history{
      position: absolute;
      bottom: 8px;
      left: 14%;
      width: 72%;
      font-weight: 400;
      font-size: 12px;
      color: #000000;
      text-align: right;
      cursor: pointer;
      padding-right: 30px;
    }
    .newChat{
      position: absolute;
      bottom: 186px;
      right: 14%;
      width: 60px;
      height: 60px;
      margin-right: -80px;
      cursor: pointer;
    }
  }
}

.chat-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

// .messages {
//   flex-grow: 1;
//   overflow-y: auto;
//   padding: 20px;
//   border-bottom: 1px solid #ccc;

//   .message {
//     margin-bottom: 16px;
//     display: flex;

//     &.user {
//       justify-content: flex-end;
//       .message-content {
//         background-color: #1890ff;
//         color: white;
//       }
//     }

//     &.assistant {
//       justify-content: flex-start;
//       .message-content {
//         background-color: #f0f2f5;
//       }
//     }

//     &.system {
//       justify-content: center;
//       .message-content {
//         background-color: #ff4d4f;
//         color: white;
//       }
//     }

//     .message-content {
//       padding: 8px 12px;
//       border-radius: 8px;
//       max-width: 70%;
//       word-break: break-word;
//     }
//   }
// }

.input-area {
  display: flex;
  flex-direction: column;
  padding: 0;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 4px 24px 0 rgba(44,59,77,0.08);
  margin: 24px 0 0 0;
  position: relative;
  min-height: 80px;
  width: 100%;
  .ant-input {
    margin-right: 10px;
    border-radius: 12px;
    height: 40px;
    font-size: 16px;
    background: #f7f8fa;
    border: none;
    box-shadow: none;
    padding: 0 16px;
  }
}

.editable-tag {
  display: inline-block;
  width: min-content;
  min-width: 120px;
  margin: 0 4px;
  border-radius: 8px;
  padding: 2px 10px;
  font-weight: 700;
  font-size: 15px;
  background: #f7f8fa;
  border: 1px solid #e6eaff;
  height: 36px;
  box-shadow: none;
}
</style>
<style lang="less">
.ai-tooltip{
  max-width: max-content;
  .ai-tooltip-content{
    padding: 4px 4px 8px 4px;
    p{
      font-weight: 600;
      font-size: 12px;
      padding-bottom: 4px;
    }
    span{
      display: block;
      font-weight: 400;
      font-size: 10px;
      color: #FFFFFF;
    }
  }
}
</style>
